module.exports = __webpack_public_path__ + "2d3781d9b294f23ebe8aa12893004ebf.fbx";